import React, { useState, useRef } from "react";
import styles from "./about.module.css";
import "antd/dist/reset.css";
import { WHO_RUNS_PHOTOS } from "../../../data/who-runs";
import { Image } from "antd";
import { useHydrated } from "../../../hooks/useHydrated";

// Импортируем Swiper вместо Carousel
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Стили Swiper
import "swiper/css";

export const MentorPhotos = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);

  // Реф для управления слайдером через миниатюры
  const swiperRef = useRef(null);
  const previewItems = WHO_RUNS_PHOTOS.map((photo) => photo.src);
  const hydrated = useHydrated();

  return (

    <div className={styles.sectionAboutImage}>
      <div className={styles.galleryContainer}>
        <div className={styles.mainImageWrapper}>
          <Image.PreviewGroup
            items={previewItems}
            preview={{
              toolbarRender: () => null,
              visible: previewOpen,
              onVisibleChange: (visible) => {
                setPreviewOpen(visible);
                if (visible) {
                  swiperRef.current?.autoplay?.stop();
                } else {
                  swiperRef.current?.autoplay?.start();
                }
              },
              onChange: (current) => {
                setActiveIndex(current);
                swiperRef.current?.slideToLoop(current); // Синхронизация при листании внутри лайтбокса
              },
            }}
          >
            {/* Swiper вместо Carousel работает стабильно */}
            {hydrated ? (
            <Swiper
              modules={[Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              loop={WHO_RUNS_PHOTOS.length > 1}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false, // Автоплей НЕ остановится при кликах
              }}
              onSwiper={(swiper) => {
                swiperRef.current = swiper; // Сохраняем инстанс слайдера в реф
              }}
              onSlideChange={(swiper) => {
                // Из-за режима loop реальный индекс слайда получаем через realIndex
                setActiveIndex(swiper.realIndex);
              }}
              className={styles.mySwiper}
            >
              {WHO_RUNS_PHOTOS.map((photo, index) => (
                <SwiperSlide key={photo.src}>
                  <Image
                    alt={photo.alt}
                    src={photo.src}
                    className={styles.mainImage}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            ) : (
              <Image
                alt={WHO_RUNS_PHOTOS[0].alt}
                src={WHO_RUNS_PHOTOS[0].src}
                className={styles.mainImage}
              />
            )}
          </Image.PreviewGroup>
        </div>

        {/* Ряд миниатюр */}
        <div className={styles.thumbnailsRow}>
          {WHO_RUNS_PHOTOS.map((photo, index) => (
            <button
              key={photo.src}
              type="button"
              className={`${styles.thumbnailButton} ${index === activeIndex ? styles.thumbnailActive : ""
                }`}
              onClick={() => {
                setActiveIndex(index);
                swiperRef.current?.slideToLoop(index); // Переключаем Swiper на нужный слайд
              }}
              aria-label={`Посмотреть фото ${index + 1}`}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className={styles.thumbnailImg}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
